
export const getCardType = (number) => {
    number = number.replace(/\D/g, '');

    if (/^4/.test(number)) {
        return "visa";
    }
    if (/^(5[1-5]|2221|222[2-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/.test(number)) {
        return "mastercard";
    }
    if (/^3[47]/.test(number)) {
        return "american_express";
    }
    if (/^(6011|65|64[4-9]|622(12[6-9]|1[3-9]\d|[2-8]\d{2}|9([01]\d|2[0-5])))/.test(number)) {
        return "discover";
    }
    return "unknown";
}

export const getCardTypeDisplay = (type) => {
    switch (type) {
        case "visa":
            return "Visa";
        case "mastercard":
            return "MasterCard";
        case "american_express":
            return "American Express";
        case "discover":
            return "Discover";
        default:
            return "Unknown";
    }
}

export const getCardNumberLength = (cardType) =>{
    switch (cardType) {
        case "visa":
        case "mastercard":
        case "discover":
            return 16;
        case "american_express":
            return 15;
        default:
            return 16; // unknown
    }
}

export const getCVVLength = (cardType) => {
    switch (cardType) {
        case "american_express":
            return 4;  // AMEX has 4-digit CVV
        case "visa":
        case "mastercard":
        case "discover":
            return 3;  // most cards use 3-digit CVV
        default:
            return 4;  // unknown
    }
}
